import React, { useState } from 'react';
import LessonList from './LessonList';
import LessonViewer from './LessonViewer';
import LessonEditor from './LessonEditor';
import { Database } from '../types/database';
import { useAuth } from '../contexts/AuthContext';

type Lesson = Database['public']['Tables']['lessons']['Row'];
type Card = Database['public']['Tables']['cards']['Row'];

interface LessonsProps {
  onStartStudy?: (cards: Card[], lessonId?: string) => void;
}

type View = 'list' | 'view' | 'edit' | 'create';

export default function Lessons({ onStartStudy }: LessonsProps) {
  const { profile } = useAuth();
  const [currentView, setCurrentView] = useState<View>('list');
  const [selectedLesson, setSelectedLesson] = useState<Lesson | null>(null);

  const handleSelectLesson = (lesson: Lesson) => {
    setSelectedLesson(lesson);
    setCurrentView('view');
  };

  const handleCreateLesson = () => {
    setSelectedLesson(null);
    setCurrentView('create');
  };

  const handleEditLesson = () => {
    setCurrentView('edit');
  };

  const handleSaveLesson = (lesson: Lesson) => {
    setSelectedLesson(lesson);
    setCurrentView('view');
  };

  const handleCancelEdit = () => {
    setCurrentView(selectedLesson ? 'view' : 'list');
  };

  const handleBack = () => {
    setCurrentView('list');
  };

  const handleStartStudy = (cards: Card[]) => {
    if (onStartStudy) {
      onStartStudy(cards, selectedLesson?.id);
    }
  };

  return (
    <div className="container mx-auto px-4 py-6">
      {currentView === 'list' && (
        <LessonList
          onSelectLesson={handleSelectLesson}
          onCreateLesson={profile?.is_admin ? handleCreateLesson : undefined}
        />
      )}

      {currentView === 'view' && selectedLesson && (
        <LessonViewer
          lesson={selectedLesson}
          onEdit={profile?.is_admin ? handleEditLesson : undefined}
          onBack={handleBack}
          onStartStudy={onStartStudy ? handleStartStudy : undefined}
        />
      )}

      {(currentView === 'edit' || currentView === 'create') && profile?.is_admin && (
        <LessonEditor
          lesson={currentView === 'edit' ? selectedLesson : null}
          onSave={handleSaveLesson}
          onCancel={handleCancelEdit}
        />
      )}
    </div>
  );
}